import React from 'react';

export default function Loader({ show, message = 'Chargement...' }) {
    if (!show) return null;

    return (
        <div className="overlay">
            <div className="loading-content">
                <div className="spinner" />
                {message && <p className="loading-text">{message}</p>}
            </div>
        </div>
    );
}
